import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class ProductBundleExtractionsService {
  searchProductBundleExtractions({ authorId, opportunityId, opportunityDocumentId, status, cancelToken = null }) {
    const data = {
      authorId,
      opportunityId,
      opportunityDocumentId,
      status,
    };
    return ApiService.post(`${Config.api.slipExtractor.url}api/v1/product-bundle-extractions/search`, data, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }
  getProductBundleExtractionById({ id, cancelToken = null }) {
    return ApiService.get(`${Config.api.slipExtractor.url}api/v1/product-bundle-extractions/${id}`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }
  addProductBundleExtraction({
    name,
    opportunityDocumentId,
    productBundleTemplateId,
    extractionOutputFileTemplateId,
    pdfPages,
    xlsSheets,
  }) {
    const data = {
      name,
      opportunityDocumentId,
      productBundleTemplateId: productBundleTemplateId,
      extractionOutputFileTemplateId: extractionOutputFileTemplateId,
      pdfPages,
      xlsSheets,
    };

    return ApiService.post(`${Config.api.slipExtractor.url}api/v1/product-bundle-extractions`, data).then(
      (response) => response.data,
    );
  }
  deleteProductBundleExtractionById({ id, cancelToken = null }) {
    return ApiService.delete(`${Config.api.slipExtractor.url}api/v1/product-bundle-extractions/${id}`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }
}

export const productBundleExtractionsService = new ProductBundleExtractionsService();
